import React, { useState, useEffect } from "react";
import './style.css';
import { AwardIcon } from "../../assets/icons/icons";
import WellnessMethodModal from "../WellnessMethodModal/WellnessMethodModal";

export default function WellnessContainer() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className="action-tile">
            <div className="action-container">
                <div className="action-title-container">
                    <h3>Wellness Reports Methodology</h3>
                    <p>Click below to learn more</p>
                </div>
                <AwardIcon className='action-icon'/>
            </div>
            <div className="action-btn-container">
                <button className="action-btn" onClick={toggleModal}>Learn More</button>
            </div>
            <WellnessMethodModal
                isOpen={isModalOpen}
                closeModal={toggleModal}
            />
        </div>
    );
}
